// extracted by css-extract-rspack-plugin
export default {"wrapper":"zGTGcW9bQsYVMAHO","checkTable":"cNlpQ1icBjkH5_q2","footer":"oT5HkXhzaI81Q_Z0","anotherFile":"vQpmA44UkxYgXndN"};